export default "<div>{{ GetStatutCommande(id) }}</div>";